import React, { Component } from 'react';
import { connect } from 'react-redux';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

import {
  saveConfig,
  updatePercentileTrendsBy,
  updatePercentileTrendsPeriod,
  updatePercentileTrendsItems,
} from '../../FilterActions';
import RadioButton from '../../../RadioButton/RadioButton';

import './LocalPercentileTrends.scss';

const PERIODS = [
  { label: 'Week', value: 'week' },
  { label: 'Month', value: 'month' },
  { label: 'Quarter', value: 'quarter' },
];
const MIN_ITEMS = 2;

export class PercentileTrendsControl extends Component {
  constructor(props) {
    super(props);
    this.state = {
      items: props.items,
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.items !== this.props.items) {
      this.setState({ items: this.props.items });
    }
  }

  handleByChange = ({ value }) => {
    this.props.updateBy(value, this.props.chart);
    this.props.saveConfig();
  };

  handlePeriodChange = ({ value }) => {
    this.props.updatePeriod(value, this.props.chart);
    this.props.saveConfig();
  };

  handleItemsChange = (event) => {
    this.setState({ items: event.target.value });
  };

  handleItemsKeyDown = (event) => {
    if (event.key === 'Enter') {
      event.target.blur();
    }
  };

  handleItemsBlur = () => {
    const items = Math.max(Math.round(+this.state.items), MIN_ITEMS);
    this.setState({ items });

    if (items !== this.props.items) {
      this.props.updateItems(items, this.props.chart);
      this.props.saveConfig();
    }
  };

  render() {
    const { by, period, items } = this.props;
    const isByItems = by === 'items';

    return (
      <div className="percentile-trends-control">
        <RadioButton
          id="percentile-trends-period"
          name="percentileTrendsBy"
          label="Time period"
          value="period"
          checked={!isByItems}
          onChange={this.handleByChange}
        />
        <p className="percentile-trends-control__description">Items completed during each selected period.</p>
        {!isByItems && (
          <div className="sublevel">
            {PERIODS.map((item) => (
              <RadioButton
                id={`percentile-trends-${item.value}`}
                key={item.value}
                name="percentileTrendsPeriod"
                label={item.label}
                value={item.value}
                checked={item.value === period}
                onChange={this.handlePeriodChange}
              />
            ))}
          </div>
        )}
        <div className="percentile-trends-control__option">
          <RadioButton
            id="percentile-trends-items"
            className="percentile-trends-control__radio"
            name="percentileTrendsBy"
            label="Fixed number of items"
            value="items"
            checked={isByItems}
            onChange={this.handleByChange}
          />
          <OverlayTrigger
            placement="top"
            overlay={
              <Tooltip id="percentileTrendsItemsTooltip" className="tooltip_white max_width_200">
                Each point is a separate group of {items} completed items. Counting starts with the most recently
                completed item, so the oldest point can have fewer. When an item is completed, every group moves by one
                item.
              </Tooltip>
            }
            delay={{ show: 250, hide: 2000 }}
          >
            <span className="more_info" />
          </OverlayTrigger>
        </div>
        <p className="percentile-trends-control__description">
          Groups of {items} completed items, counted from the most recent.
        </p>
        {isByItems && (
          <div className="percentile-trends-control__items">
            <label htmlFor="percentile-trends-number">Number of items</label>
            <input
              id="percentile-trends-number"
              name="percentile-trends-number"
              type="number"
              min={MIN_ITEMS}
              step="1"
              className="form-control"
              value={this.state.items}
              onChange={this.handleItemsChange}
              onKeyDown={this.handleItemsKeyDown}
              onBlur={this.handleItemsBlur}
            />
          </div>
        )}
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    saveConfig: () => dispatch(saveConfig()),
    updateBy: (value, chart) => dispatch(updatePercentileTrendsBy(value, chart)),
    updatePeriod: (value, chart) => dispatch(updatePercentileTrendsPeriod(value, chart)),
    updateItems: (value, chart) => dispatch(updatePercentileTrendsItems(value, chart)),
  };
};

const mapStateToProps = (state) => {
  const chart = state.filters.chart;
  return {
    chart,
    by: state.filters[chart].percentileTrendsBy,
    period: state.filters[chart].percentileTrendsPeriod,
    items: state.filters[chart].percentileTrendsItems,
  };
};

const connected = connect(mapStateToProps, mapDispatchToProps)(PercentileTrendsControl);
export { connected as LocalPercentileTrends };
